import React, { useEffect, useRef } from 'react';

function parsePlace(place) {
  const get = (type, useLong = false) => {
    const comp = (place.address_components || []).find((c) => c.types.includes(type));
    return comp ? (useLong ? comp.long_name : comp.short_name) : '';
  };
  return {
    street: [get('street_number', true), get('route', true)].filter(Boolean).join(' '),
    city:
      get('locality', true) ||
      get('sublocality_level_1', true) ||
      get('postal_town', true) ||
      get('administrative_area_level_2', true),
    state: get('administrative_area_level_1'),
    zip: get('postal_code'),
  };
}

export default function AddressAutocomplete({
  value,
  onChange,
  onSelect,
  name,
  placeholder,
  className,
  disabled,
  ...rest
}) {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const onSelectRef = useRef(onSelect);
  onSelectRef.current = onSelect;

  useEffect(() => {
    if (disabled) return;

    function init() {
      if (!inputRef.current || !window.google?.maps?.places) return;
      if (autocompleteRef.current) return;

      const ac = new window.google.maps.places.Autocomplete(inputRef.current, {
        types: ['address'],
        componentRestrictions: { country: 'us' },
        fields: ['address_components'],
      });

      ac.addListener('place_changed', () => {
        const place = ac.getPlace();
        if (!place.address_components) return;
        if (onSelectRef.current) onSelectRef.current(parsePlace(place));
      });

      autocompleteRef.current = ac;
    }

    if (window.google?.maps?.places) {
      init();
    } else {
      window.addEventListener('google-maps-ready', init);
      return () => window.removeEventListener('google-maps-ready', init);
    }
  }, [disabled]);

  return (
    <input
      ref={inputRef}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      autoComplete="new-password"
      {...rest}
    />
  );
}
